/**
 * Visitor premium download A/B/C test (DEV-7217). A GrowthBook string feature
 * whose experiment rule splits logged-out visitors on a premium Music download
 * 33/33/33. `control` keeps the premium-gate journey; `A` signs up
 * first, then picks a plan (closer to the general sign-up flow); `B`
 * signs up, then gets the old side-modal upsell. Assignment is sticky via
 * GrowthBook's cookie bucketing on the device id.
 */
export const VISITOR_PREMIUM_DOWNLOAD_FEATURE = 'visitor-premium-download-test';

export const VISITOR_PREMIUM_DOWNLOAD_VARIANTS = ['control', 'A', 'B'] as const;

export type VisitorPremiumDownloadVariant =
  (typeof VISITOR_PREMIUM_DOWNLOAD_VARIANTS)[number];

/** Anything unexpected (feature missing, typo'd value) falls back to control. */
export const toVisitorPremiumDownloadVariant = (
  value: unknown
): VisitorPremiumDownloadVariant =>
  VISITOR_PREMIUM_DOWNLOAD_VARIANTS.find((variant) => variant === value) ??
  'control';
